import React from 'react';
import PropTypes from 'prop-types';

export default class FieldRating_InlineEditableStatefull extends React.Component<any,any> {
    static propTypes = {
        field: PropTypes.object,
        value: PropTypes.number,

        showEmpty: PropTypes.bool,
        disabled: PropTypes.bool,

        onChange: PropTypes.func,
    }

    static defaultProps = {
        value: 0,
        showEmpty: true
    }

    state = {
        value: this.props.value,
        displayValue: null
    }

    onStarMouseEnter = (e:React.SyntheticEvent, value:any) => {
        if (this.props.disabled) return

        this.setState({
            displayValue: value
        });
    }

    onStarMouseLeave = (e:React.SyntheticEvent) => {
        if (this.props.disabled) return

        this.setState({
            displayValue: null,
        });
    }

    onClick = (e:React.SyntheticEvent, value:any) => {
        if (this.props.disabled) return

        const newValue = _.isNil(value) ? 0 : value;
        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue);
        });
    }

    onReset = (e:React.SyntheticEvent) => {
        this.onClick(e, null);
    }

    render() {
        const value = this.state.displayValue ? this.state.displayValue : this.state.value;
        const stars = new Array(this.props.field.scale).fill(true).fill(false, value);

        const classes = Classes("ui5-selector-rating", {
            'is-empty': !this.state.value,
            'show-empty': this.props.showEmpty
        })

        return (
            <div className={Classes("ui5-field-form-editable no-border min-h-36 p-l-10 p-r-10", this.props.className)}>
                <div className={classes}>
                    {_.map(stars, (value, key)=>{
                        const classes = Classes("icon", {
                            'filled i5-star': value,
                            'empty i5-star-empty': !value,
                        });
                        const starValue = key + 1;
                        return <div key={key}
                                    className={classes}
                                    onMouseEnter={e=>{this.onStarMouseEnter(e,starValue)}}
                                    onMouseLeave={e=>{this.onStarMouseLeave(e)}}
                                    onClick={e=>this.onClick(e, starValue)}/>
                    })}

                    {!!this.state.value && this.props.field.clearButton &&
                        <div className="delete-button ui5-ico-trash red s-14" onClick={this.onReset}/>}
                </div>
            </div>
        )
    }
}